<template>
  <div id="zarpe">
    <!-- Modal de teléfono -->
    <div class="wrap-modal-phone position-absolute" v-if="isShowModalPhone">
      <div class="modal">
        <div v-if="modalPhoneNumber">
          <h2 class="mt-4 mb-3">{{ modalPhoneNumber }}</h2>
          <div class="w-75 m-auto">
            <a class="call mb-3 btn-call" :href="`tel:${modalPhoneNumber}`">Llamar</a>
          </div>
        </div>
        <div v-if="!modalPhoneNumber">
          <h4 class="mt-4">Teléfono no registrado</h4>
        </div>
        <div class="w-100 mt-4 float-left">
          <div class="d-block btn-close" @click="closeModalPhone()">cerrar</div>
        </div>
      </div>
    </div>

    <div class="padding-ios"></div>

    <!-- Tabla de servicio -->
    <table class="reco w-100 mb-3" :class="service.hour_init_movil ? 'active' : 'disable'" align="center" border="1" style="border-color: #eee">
      <tr>
        <td class="background-app" colspan="2" width="100%" align="center">SERVICIO</td>
      </tr>
      <tr>
        <td class="text-center" width="50%">
          <strong>TIPO:</strong>{{ IDPaysType ? ' ' + IDPaysType : ' ' + service.type | uppercase }}
        </td>
        <td class="text-center" width="50%">{{ IDPays ? IDPays : service.id_pay | uppercase }}</td>
      </tr>
      <tr v-if="service.driver_instructions">
        <td class="p-1 text-center" colspan="2">
          <strong>INFO:</strong>{{ ' ' + service.driver_instructions }}
        </td>
      </tr>
    </table>

    <!-- Tabla de pasajeros -->
    <table class="zarpe w-100" :class="service.hour_init_movil ? 'active' : 'disable'" align="center" :key="updateKey">
      <tr>
        <td class="background-app" colspan="6" align="center" width="100%" height="40">
          PASAJEROS {{ (service.rtx_type ? service.rtx_type : IDPaysType) + ' ' + IDPays | uppercase }}
        </td>
      </tr>
      <tr class="header" bgcolor="#CCCCCC">
        <td width="30" align="center" v-if="passengersShowPhone"></td>
        <td colspan="2" align="center" height="30">
          <strong>Nombre</strong>
        </td>
        <td align="center">
          <strong>Dirección</strong>
        </td>
        <td align="center">
          <strong>Comuna</strong>
        </td>
        <td width="15%" align="center">
          <strong>Trasladó funcionario</strong>
        </td>
      </tr>
      <tr
        v-for="(passenger, index) in service.passengers"
        :key="passenger.id"
        class="font-14"
        style="border-bottom: 1px solid #ccc"
        :bgcolor="passenger.transfer != null ? '#8FBBDF' : ''"
      >
        <td v-if="passengersShowPhone">
          <button class="tel" @click="showModalPhone(passenger.phone)">
            <img src="/static/img/phone-call-small.png" width="24"/>
          </button>
        </td>
        <td width="22%" colspan="2" align="center">{{ passenger.name | upperCase }}</td>
        <td width="45%" align="center">
          <a class="show-only-android" :href="`geo://?q=${passenger.localization}`" target="_blank">{{ passenger.address }}</a>
          <a class="show-only-ios" :href="`https://www.waze.com/ul?navigate=yes&ll=${passenger.localization}`" target="_blank">{{ passenger.address }}</a>
        </td>
        <td width="13%" align="center">{{ passenger.commune }}</td>
        <td width="8%" align="center">
          <table class="w-100" height="70" align="center">
            <tbody v-if="passenger.transfer == null">
              <tr>
                <td @click="setTransferState(passenger.id, 1, index)" bgcolor="#00CC00" align="center" style="color:#ffffff; font-size:20px">SI</td>
              </tr>
              <tr>
                <td @click="setTransferState(passenger.id, 0, index)" bgcolor="#FF0000" align="center" style="color:#ffffff; font-size:20px">NO</td>
              </tr>
            </tbody>
            <tbody v-if="passenger.transfer != null">
              <tr>
                <td style="font-size:20px" align="center">{{ passenger.transfer ? 'SI' : 'NO' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>

    <!-- Estado de ruta -->
    <div v-if="service.state && !finishedRoute">
      <table width="100%" height="15%" align="center" border="0" cellpadding="2" cellspacing="2">
        <tbody>
          <tr style="border:0;">
            <td class="background-app" colspan="3" style="text-align: center ; padding: 10px 0;" align="center">
              <span style="font-size: 20px; color: #FFF; ">ESTADO DE RUTA: {{service.state == 'rejected' ? 'RECHAZADA' : 'ACEPTADA' }}</span>
            </td>
          </tr>
          <tr v-if="!service.hour_init_movil">
            <td height="140">
              <div class="pullee-container">
                <div class="text">Iniciar servicio</div>
                <input class="pullee ml-auto mr-auto d-block" type="range" min="0" max="150" value="0" step="1"/>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Confirmar ruta -->
    <div v-if="!service.state && getServiceId()">
      <table align="center" border="0" cellpadding="2" cellspacing="2">
        <tbody>
          <tr>
            <td class="background-app" colspan="3" style="text-align: center" align="center">
              <span style="color: #FFF; ">CONFIRMAR</span>
            </td>
          </tr>
          <tr>
            <td style="text-align: center">
              <img src="/static/img/confirm.png" width="80" @click="setState('accepted')"/>
            </td>
          </tr>
          <tr>
            <td style="text-align: center">
              <span class="color-text-app"><strong>PARA VER EL DETALLE POR PASAJERO, PRIMERO DEBE ACEPTAR LA RUTA</strong></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Agregar pasajero -->
    <div v-if="service.type != 'rtx_zarpe'">
      <div id="addPassenger" v-if="!finishedRoute && (service.state == 'accepted' || service.state == 'in progress')" style="height: 140px; display: flex;">
        <img v-if="!service.add_passenger" src="/static/img/add-user.png" style="margin: auto; display: block; width: 120px;" @click="addPassenger()"/>
        <p class="color-text-app" v-if="service.add_passenger" style="font-size: 20px; text-align: center; display: flex; align-items: center; justify-content: center; width: 100%;">
          <strong>SERVICIO YA INFORMADO</strong>
        </p>
      </div>
    </div>

    <!-- Finalizar servicio para apoyo bus -->
    <div v-if="(service.rtx_type == 'apoyo bus mant' || service.rtx_type == 'apoyo bus corp') || service.rtx_type == 'mall'">
      <div v-if="service.passengers[0].transfer === 1">
        <img src="/static/img/alert.png" style="margin: 20px auto; display: block; width: 120px;"/>
        <p class="color-text-app" style="font-size: 20px; text-align: center; display: flex; align-items: center; justify-content: center; width: 100%;">
          <strong>SERVICIO PENDIENTE, SERÁ FINALIZADO POR LA CENTRAL</strong>
        </p>
      </div>
      <div v-if="service.passengers[0].transfer === 0">
        <table width="100%" height="15%" align="center" border="0" cellpadding="2" cellspacing="2">
          <tbody>
            <tr>
              <td class="background-app" colspan="3" style="text-align: center" align="center">
                <span style="font-size: 18px; color: #FFF; display: inline-block; padding: 10px 0;">FINALIZAR SERVICIO</span>
              </td>
            </tr>
            <tr>
              <td style="text-align: center">
                <img src="/static/img/door.png" width="80" style="margin: 15px 0;" @click="endService()"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Finalizar servicio normal -->
    <div v-if="(service.rtx_type != 'apoyo bus mant' && service.rtx_type != 'apoyo bus corp') && service.rtx_type != 'mall'">
      <div v-if="finishedRoute && service.add_passenger != 1">
        <table width="100%" height="15%" align="center" border="0" cellpadding="2" cellspacing="2">
          <tbody>
            <tr>
              <td class="background-app" colspan="3" style="text-align: center" align="center">
                <span style="font-size: 18px; color: #FFF; display: inline-block; padding: 10px 0;">FINALIZAR SERVICIO</span>
              </td>
            </tr>
            <tr>
              <td style="text-align: center">
                <img src="/static/img/door.png" width="80" style="margin: 15px 0;" @click="endService()"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="finishedRoute && service.add_passenger == 1">
        <img src="/static/img/alert.png" style="margin: 20px auto; display: block; width: 120px;"/>
        <p class="color-text-app" style="font-size: 20px; text-align: center; display: flex; align-items: center; justify-content: center; width: 100%;">
          <strong>SERVICIO PENDIENTE, SERÁ FINALIZADO POR LA CENTRAL</strong>
        </p>
      </div>
    </div>

    <!-- Volver a aeropuerto -->
    <table align="center" width="100%">
      <tbody>
        <tr style="border:0">
          <td align="center" colspan="5" height="65" valign="middle" style="vertical-align: middle">
            <span style="text-align: center; font-size: 20px; color: #f00">
              <strong>
                <a class="show-only-android" href="geo://?q=-33.396792,-70.793338" target="_blank" style="text-decoration:none;">VOLVER A AEROPUERTO</a>
                <a class="show-only-ios" href="https://www.waze.com/ul?navigate=yes&ll=-33.396792,-70.793338" target="_blank" style="text-decoration:none;">VOLVER A AEROPUERTO</a>
              </strong>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Zarpe',
  data() {
    return {
      service: {},
      IDPays: '',
      IDPaysType: '',
      passengersShowPhone: false,
      finishedRoute: false,
      isShowModalPhone: false,
      modalPhoneNumber: '',
      updateKey: 0,
      passenger_id: null,
      position: { lat: undefined, lng: undefined }
    }
  },
  created() {
    this.loadZarpeData()
  },
  filters: {
    uppercase(value) {
      return value ? value.toUpperCase() : ''
    },
    upperCase(value) {
      return value ? value.toUpperCase() : ''
    }
  },
  methods: {
    getServiceId() {
      return this.service.id_pay || this.IDPays || this.$route.params.id
    },
    async fetchAppPassengersShowPhone() {
      try {
        const response = await http.get('app/settings/app_passengers_show_phone')
        this.passengersShowPhone = response.body.success === true
      } catch (err) {
        console.error('Error fetching passengers show phone setting:', err)
        this.passengersShowPhone = false
      }
    },
    loadZarpeData() {
      const zarpeId = this.$route.params.id
      this.IDPays = zarpeId
      this.IDPaysType = 'zarpe'

      this.fetchAppPassengersShowPhone()

      http.get(`app/service/${zarpeId}`)
        .then(res => {
          this.service = res.body.service
          this.finishedRoute = true

          // Verificar si todos los pasajeros están procesados
          this.service.passengers.forEach(passenger => {
            if (passenger.transfer === null) {
              this.finishedRoute = false
            }
          })

          // Cargar pullee si el servicio está aceptado y no ha iniciado
          if (this.service.state === 'accepted' && !this.service.hour_init_movil) {
            this.$nextTick(() => {
              this.loadPullee()
            })
          }

          this.$nextTick(() => {
            this.updateKey++
          })

        })
        .catch(err => {
          console.error('Error loading zarpe data:', err)
        })
    },
    showModalPhone(phone) {
      this.modalPhoneNumber = phone
      this.isShowModalPhone = true
    },
    closeModalPhone() {
      this.isShowModalPhone = false
      this.modalPhoneNumber = ''
    },
    setTransferState(passengerId, transfer, index) {
      this.passenger_id = passengerId
      this.$forceUpdate()

      http.put(`app/passenger/${passengerId}/transfer/${transfer}`)
        .then(() => {
          this.service.passengers[index].transfer = transfer
          this.finishedRoute = true
          this.service.passengers.forEach(passenger => {
            if (passenger.transfer === null) {
              this.finishedRoute = false
            }
          })
          setTimeout(() => {
            this.loadZarpeData()
          }, 100)
        })
        .catch(err => {
          console.error('Error setting transfer state:', err)
        })

      http.put(`app/passenger/${passengerId}/time/00:00:00`)
        .catch(err => {
          console.error('Error resetting passenger time:', err)
        })

      this.sendPassengerLocalization(passengerId)
    },
    sendPassengerLocalization(passengerId) {
      if (!navigator.geolocation) return

      navigator.geolocation.getCurrentPosition(
        position => {
          this.position = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (this.isPositionCapture()) {
            http.put(`app/passenger/${passengerId}/localization-movil/${this.position.lat}/${this.position.lng}`)
              .then(() => {
                this.position = { lat: undefined, lng: undefined }
              })
              .catch(err => {
                console.error('Error sending localization:', err)
              })
          } else {
            this.startPositionPolling(passengerId)
          }
        },
        () => {
          this.startPositionPolling(passengerId)
        },
        { timeout: 3000, enableHighAccuracy: false }
      )
    },
    startPositionPolling(passengerId) {
      const positionInterval = setInterval(() => {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.position = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          },
          err => {
            console.error('Error getting position:', err)
          },
          { timeout: 10000, enableHighAccuracy: false }
        )

        const watchId = navigator.geolocation.watchPosition(
          position => {
            this.position = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          },
          () => {},
          { timeout: 3000, enableHighAccuracy: false }
        )
        navigator.geolocation.clearWatch(watchId)

        if (this.isPositionCapture()) {
          http.put(`app/passenger/${passengerId}/localization-movil/${this.position.lat}/${this.position.lng}`)
            .catch(err => {
              console.error('Error sending localization:', err)
            })
          clearInterval(positionInterval)
        }
      }, 3000)
    },
    isPositionCapture() {
      return !(this.position.lat === undefined || this.position.lat === 0 ||
        this.position.lng === undefined || this.position.lng === 0)
    },
    setState(state, idPay) {
      const serviceId = idPay || this.getServiceId()
      if (!serviceId) {
        console.error('Service ID is required')
        return
      }
      if (confirm('¿Está seguro?')) {
        http.put(`app/service/${serviceId}/state/${state}`, { reason: false })
          .then(res => {
            this.service.state = state
            this.finishedRoute = false
            if (state === 'rejected') {
              this.$router.push('/zarpes')
            } else if (state === 'accepted') {
              // Cargar pullee después de aceptar el servicio
              this.$nextTick(() => {
                setTimeout(() => {
                  this.loadPullee()
                }, 600)
              })
            }
            this.loadZarpeData()
          })
          .catch(err => {
            console.error('Error setting state:', err)
          })
      }
    },
    addPassenger(idPay) {
      const serviceId = idPay || this.getServiceId()
      if (!serviceId) return

      http.post(`app/service/${serviceId}/add-passenger`)
        .then(res => {
          this.service.add_passenger = 1
          this.loadZarpeData()
        })
        .catch(err => {
          console.error('Error adding passenger:', err)
        })
    },
    endService(idPay) {
      const serviceId = idPay || this.getServiceId()
      if (!serviceId) return

      http.post(`app/rates/finished/${serviceId}`)
        .then(res => {
          alert(`Servicio: ${serviceId} finalizado`)
          this.$router.push('/menu')
        })
        .catch(err => {
          console.error('Error ending service:', err)
          this.$router.push('/menu')
        })
    },
    loadPullee() {
      const pulleeElement = document.getElementsByClassName("pullee")[0]
      if (!pulleeElement) return

      let animationId
      let currentValue = 0

      const onMouseDown = () => {
        window.cancelAnimationFrame(animationId)
        currentValue = +pulleeElement.value
      }

      const onMouseUp = () => {
        currentValue = +pulleeElement.value
        if (currentValue >= 150) {
          this.startService()
        } else {
          animationId = window.requestAnimationFrame(animateBack)
        }
      }

      const animateBack = () => {
        if (currentValue > -1) {
          pulleeElement.value = currentValue
          window.requestAnimationFrame(animateBack)
        }
        currentValue -= 12
      }

      pulleeElement.value = 0
      pulleeElement.addEventListener("mousedown", onMouseDown, false)
      pulleeElement.addEventListener("mousestart", onMouseDown, false)
      pulleeElement.addEventListener("mouseup", onMouseUp, false)
      pulleeElement.addEventListener("touchend", onMouseUp, false)
      pulleeElement.addEventListener("input", () => {
        currentValue = +pulleeElement.value
      }, false)
    },
    startService() {
      this.service.hour_init_movil = 'temporal'
      http.put(`app/service/${this.getServiceId()}/hour-init-movil`)
        .then(res => {
          this.service.hour_init_movil = res.body.hour_init_movil
          this.loadZarpeData()
        })
        .catch(err => {
          console.error('Error starting service:', err)
        })
    }
  }
}
</script>

<style lang="css">
.wrap-modal-phone {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrap-modal-phone .modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  height: 32% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Zarpe.vue